import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Trans, t } from "@lingui/macro";
import { FiArrowUpRight } from "react-icons/fi";
import { HiArrowNarrowDown, HiArrowNarrowUp } from "react-icons/hi";
import useSWR from "swr";
import { useWeb3React } from "@web3-react/core";
import { ethers } from "ethers";

import "./Buy.css";
import SEO from "components/Common/SEO";
import { getPageTitle } from "lib/legacy";
import PalmToken from "img/PalmToken.svg";
import PlpToken from "img/plpToken.png";
import Pancake from "img/pancake.png";
import cx from "classnames";
import Button from "components/Button/Button";
import Tooltip from "../../components/Tooltip/Tooltip";
import ExternalLink from "../../components/ExternalLink/ExternalLink";
import BuyInputSection from "../../components/BuyInputSection/BuyInputSection";
import { getContract } from "config/contracts";
import {
  getBuyGlpToAmount,
  getBuyGlpFromAmount,
  getSellGlpFromAmount,
  getSellGlpToAmount,
  adjustForDecimals,
  GLP_DECIMALS,
  USD_DECIMALS,
  BASIS_POINTS_DIVISOR,
  GLP_COOLDOWN_DURATION,
  SECONDS_PER_YEAR,
  USDG_DECIMALS,
  PLACEHOLDER_ACCOUNT,
  importImage,
} from "lib/legacy";
import Reader from "abis/Reader.json";
import RewardReader from "abis/RewardReader.json";
import PlpManager from "abis/PlpManager.json";
import RewardTracker from "abis/RewardTracker.json";
import LiquidityEvent from "abis/events/LiquidityEvent.json";
import Token from "abis/Token.json";
import { TESTNET, getChainName, IS_NETWORK_DISABLED } from "config/chains";
import { callContract, contractFetcher } from "lib/contracts";
import { approveTokens, useInfoTokens } from "domain/tokens";
import { useLocalStorageByChainId } from "lib/localStorage";
import { getTokenInfo, getUsd } from "domain/tokens/utils";
import { bigNumberify, expandDecimals, formatAmount, formatAmountFree, formatKeyAmount, parseValue } from "lib/numbers";
import { getToken, getTokens, getWhitelistedTokens, TOKENS } from "config/tokens";
import BuyPlpModal from "./BuyPlpModal";
import SellPlpWarningModal from "./SellPlpWarningModal";
import Chart from "./Chart";
import { CHART_PERIODS_CONFIG } from "./constants";
import { useHourlyPlpStats } from '../../domain/stats/useGlpStats'

const { AddressZero } = ethers.constants;
const savedShouldDisableValidationForTesting = false;

function getStakingData(stakingInfo) {
  if (!stakingInfo || stakingInfo.length === 0) {
    return;
  }

  const keys = ["feeGlpTracker"];
  const data = {};
  const propsLength = 5;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    data[key] = {
      claimable: stakingInfo[i * propsLength],
      tokensPerInterval: stakingInfo[i * propsLength + 1],
      averageStakedAmounts: stakingInfo[i * propsLength + 2],
      cumulativeRewards: stakingInfo[i * propsLength + 3],
      totalSupply: stakingInfo[i * propsLength + 4],
    };
  }

  return data;
}

const chainId = TESTNET;

const tabsOptions = ["PLP", "PALM"];
const plpActions = ["buy", "sell"];

function hasDestroyedRewardsOnSell(destroyAmounts) {
  if (!destroyAmounts) {
    return false
  }

  // Check zero destroy amount
  let  hasDestroyRewards = false
  destroyAmounts?.destroyedRewards.forEach(destroyReward => {
    if (!destroyReward.isZero()) hasDestroyRewards = true
  })

  return hasDestroyRewards
}

export default function BuyGMXGLP(props) {
  const [activeTab, setActiveTab] = useState("PLP");
  const [activeAction, setActiveAction] = useState("buy");
  const [activeChartPeriod, setActiveChartPeriod] = useState(CHART_PERIODS_CONFIG[2].value);
  const [priceFromChart, setPriceFromChart] = useState();
  const [showMore, setShowMore] = useState(false);

  const showMoreText = !showMore
    ? t`...`
    : t` is directly linked to the value of USDT. PLP can be bought and sold on the Palmswap platform, and can be redeemed for USDT at any time. The PLP price may differ from USDT, a price difference occurs when traders make profits or losses, because the liquidity pool is used as a counterparty of traders.`;
  const handleShowMoreClick = () => setShowMore(!showMore);
  const showMoreButtonText = !showMore ? t`Show more` : t`Hide`;

  const isActiveChartPeriod = (period) => {
    return activeChartPeriod === period;
  };

  const isActive = (tab) => {
    return activeTab === tab;
  };

  const isActiveAction = (action) => {
    return activeAction === action;
  };

  const getLink = () => {
    if (activeTab === tabsOptions[1]) {
      return "https://pancakeswap.finance/swap?outputCurrency=0x29745314B4D294B7C77cDB411B8AAa95923aae38";
    }
    if (activeTab === tabsOptions[0]) {
      return "https://pancakeswap.finance/add/BNB/0x29745314B4D294B7C77cDB411B8AAa95923aae38";
    }
  };

  let { active, account, library } = useWeb3React();
  const history = useHistory();
  const [isBuying, setIsBuying] = useState(true);
  const swapLabel = isBuying ? "BuyPlp" : "SellPlp";
  const tokens = getTokens(chainId);
  const whitelistedTokens = getWhitelistedTokens(chainId);
  const tokenList = whitelistedTokens.filter((t) => !t.isWrapped);
  const visibleTokens = tokenList.filter((t) => !t.isTempHidden && t.name === "Tether");
  const [swapValue, setSwapValue] = useState("");
  const [plpValue, setPlpValue] = useState("");
  const [swapTokenAddress] = useLocalStorageByChainId(
    chainId,
    `${swapLabel}-swap-token-address`,
    TOKENS[chainId].find((t) => t.name === "Tether").address
  );
  const [isApproving, setIsApproving] = useState(false);
  const [isWaitingForApproval, setIsWaitingForApproval] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [anchorOnSwapAmount, setAnchorOnSwapAmount] = useState(true);
  const [feeBasisPoints, setFeeBasisPoints] = useState("");
  const [setModalError] = useState(false);
  const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
  const [modalWarningOpen, setModalWarningOpen] = useState(false);

  const buyInputAmountRef = useRef(null);
  const sellInputAmountRef = useRef(null);

  const readerAddress = getContract(chainId, "Reader");
  const rewardReaderAddress = getContract(chainId, "RewardReader");
  const nativeTokenAddress = getContract(chainId, "NATIVE_TOKEN");
  const plpAddress = getContract(chainId, "GLP");
  const feePlpTrackerAddress = getContract(chainId, "FeePlpTracker");
  const usdgAddress = getContract(chainId, "USDG");
  const plpManagerAddress = getContract(chainId, "PlpManager");
  // TODO Buy and sell should be done via LiquidityEvent contract during the liquidity event to track rewards. After that we would need to re-enable RewardRouter
  // const plpRewardRouterAddress = getContract(chainId, "RewardRouter");
  const liquidityEventAddress = getContract(chainId, "LiquidityEvent");

  const tokensForBalanceAndSupplyQuery = [plpAddress, usdgAddress];

  const tokenAddresses = tokens.map((token) => token.address);
  const { data: tokenBalances } = useSWR(
    [`PlpSwap:getTokenBalances:${active}`, chainId, readerAddress, "getTokenBalances", account || PLACEHOLDER_ACCOUNT],
    contractFetcher(library, Reader, [tokenAddresses])
  );

  const { data: balancesAndSupplies } = useSWR(
    [
      `PlpSwap:getTokenBalancesWithSupplies:${active}`,
      chainId,
      readerAddress,
      "getTokenBalancesWithSupplies",
      account || PLACEHOLDER_ACCOUNT,
    ],
    contractFetcher(library, Reader, [tokensForBalanceAndSupplyQuery])
  );

  const { data: aums } = useSWR(
    [`PlpSwap:getAums:${active}`, chainId, plpManagerAddress, "getAums"],
    contractFetcher(library, PlpManager)
  );

  const tokenAllowanceAddress = swapTokenAddress === AddressZero ? nativeTokenAddress : swapTokenAddress;
  const { data: tokenAllowance } = useSWR(
    [active, chainId, tokenAllowanceAddress, "allowance", account || PLACEHOLDER_ACCOUNT, plpManagerAddress],
    contractFetcher(library, Token)
  );

  const { data: lastPurchaseTime } = useSWR(
    [`PlpSwap:lastPurchaseTime:${active}`, chainId, plpManagerAddress, "lastAddedAt", account || PLACEHOLDER_ACCOUNT],
    contractFetcher(library, PlpManager)
  );

  const { data: plpBalance } = useSWR(
    [`PlpSwap:plpBalance:${active}`, chainId, feePlpTrackerAddress, "stakedAmounts", account || PLACEHOLDER_ACCOUNT],
    contractFetcher(library, RewardTracker)
  );

  const rewardTrackersForStakingInfo = [feePlpTrackerAddress];
  const { data: stakingInfo } = useSWR(
    [`PlpSwap:stakingInfo:${active}`, chainId, rewardReaderAddress, "getStakingInfo", account || PLACEHOLDER_ACCOUNT],
    contractFetcher(library, RewardReader, [rewardTrackersForStakingInfo])
  );

  const stakingData = getStakingData(stakingInfo);

  const redemptionTime = lastPurchaseTime ? lastPurchaseTime.add(GLP_COOLDOWN_DURATION) : undefined;
  const inCooldownWindow = redemptionTime && parseInt(Date.now() / 1000) < redemptionTime;

  const plpSupply = balancesAndSupplies ? balancesAndSupplies[1] : bigNumberify(0);
  const usdgSupply = balancesAndSupplies ? balancesAndSupplies[3] : bigNumberify(0);
  let aum;
  if (aums && aums.length > 0) {
    aum = isBuying ? aums[0] : aums[1];
  }
  // TODO: use it
  const plpPrice =
    aum && aum.gt(0) && plpSupply.gt(0)
      ? aum.mul(expandDecimals(1, GLP_DECIMALS)).div(plpSupply)
      : expandDecimals(1, USD_DECIMALS);

  const plpSupplyUsd = plpSupply.mul(plpPrice).div(expandDecimals(1, GLP_DECIMALS));

  let maxSellAmount = plpBalance;

  const { infoTokens } = useInfoTokens(library, chainId, active, tokenBalances, undefined);
  const swapToken = getToken(chainId, swapTokenAddress);
  const swapTokenInfo = getTokenInfo(infoTokens, swapTokenAddress);

  const swapTokenBalance = swapTokenInfo && swapTokenInfo.balance ? swapTokenInfo.balance : bigNumberify(0);

  const swapAmount = parseValue(swapValue, swapToken && swapToken.decimals);
  const plpAmount = parseValue(plpValue, GLP_DECIMALS);

  const needApproval =
    isBuying && swapTokenAddress !== AddressZero && tokenAllowance && swapAmount && swapAmount.gt(tokenAllowance);

  const swapUsdMin = getUsd(swapAmount, swapTokenAddress, false, infoTokens);
  const plpUsdMax = plpAmount && plpPrice ? plpAmount.mul(plpPrice).div(expandDecimals(1, GLP_DECIMALS)) : undefined;

  const { data: destroyAmounts } = useSWR(
    [
      `LiquidityEvent:destroyAmounts:${active}`,
      chainId,
      liquidityEventAddress,
      "previewDestroyAmounts",
      account || PLACEHOLDER_ACCOUNT,
    ],
    contractFetcher(library, LiquidityEvent, [plpAmount ?? bigNumberify(0)])
  );

  const { data: isEventEnded } = useSWR(
    [`LiquidityEvent:isEventEnded:${active}`, chainId, liquidityEventAddress, "eventEnded"],
    contractFetcher(library, LiquidityEvent)
  );

  let isSwapTokenCapReached;
  if (swapTokenInfo.managedUsd && swapTokenInfo.maxUsdgAmount) {
    isSwapTokenCapReached = swapTokenInfo.managedUsd.gt(
      adjustForDecimals(swapTokenInfo.maxUsdgAmount, USDG_DECIMALS, USD_DECIMALS)
    );
  }

  const onSwapValueChange = (e) => {
    setAnchorOnSwapAmount(true);
    setSwapValue(e.target.value);
  };

  const onPlpValueChange = (e) => {
    setAnchorOnSwapAmount(false);
    setPlpValue(e.target.value);
  };

  const nativeToken = getTokenInfo(infoTokens, AddressZero);

  let totalApr = bigNumberify(0);

  let feePlpTrackerAnnualRewardsUsd;
  let feePlpTrackerApr;
  if (
    stakingData &&
    stakingData.feeGlpTracker &&
    stakingData.feeGlpTracker.tokensPerInterval &&
    nativeToken &&
    nativeToken.minPrice &&
    plpSupplyUsd &&
    plpSupplyUsd.gt(0)
  ) {
    feePlpTrackerAnnualRewardsUsd = stakingData.feeGlpTracker.tokensPerInterval
      .mul(SECONDS_PER_YEAR)
      .mul(nativeToken.minPrice)
      .div(expandDecimals(1, 18));
    feePlpTrackerApr = feePlpTrackerAnnualRewardsUsd.mul(BASIS_POINTS_DIVISOR).div(plpSupplyUsd);
    totalApr = totalApr.add(feePlpTrackerApr);
  }

  useEffect(() => {
    const updateSwapAmounts = () => {
      if (anchorOnSwapAmount) {
        if (!swapAmount) {
          setPlpValue("");
          setFeeBasisPoints("");
          return;
        }

        if (isBuying) {
          const { amount: nextAmount, feeBasisPoints: feeBps } = getBuyGlpToAmount(
            swapAmount,
            swapTokenAddress,
            infoTokens,
            plpPrice,
            usdgSupply
          );
          const nextValue = formatAmountFree(nextAmount, GLP_DECIMALS, GLP_DECIMALS);
          setPlpValue(nextValue);
          setFeeBasisPoints(feeBps);
        } else {
          const { amount: nextAmount, feeBasisPoints: feeBps } = getSellGlpFromAmount(
            swapAmount,
            swapTokenAddress,
            infoTokens,
            plpPrice,
            usdgSupply
          );
          const nextValue = formatAmountFree(nextAmount, GLP_DECIMALS, GLP_DECIMALS);
          setPlpValue(nextValue);
          setFeeBasisPoints(feeBps);
        }

        return;
      }

      if (!plpAmount) {
        setSwapValue("");
        setFeeBasisPoints("");
        return;
      }

      if (swapToken) {
        if (isBuying) {
          const { amount: nextAmount, feeBasisPoints: feeBps } = getBuyGlpFromAmount(
            plpAmount,
            swapTokenAddress,
            infoTokens,
            plpPrice,
            usdgSupply
          );
          const nextValue = formatAmountFree(nextAmount, swapToken.decimals, swapToken.decimals);
          setSwapValue(nextValue);
          setFeeBasisPoints(feeBps);
        } else {
          const { amount: nextAmount, feeBasisPoints: feeBps } = getSellGlpToAmount(
            plpAmount,
            swapTokenAddress,
            infoTokens,
            plpPrice,
            usdgSupply,
            true
          );

          const nextValue = formatAmountFree(nextAmount, swapToken.decimals, swapToken.decimals);
          setSwapValue(nextValue);
          setFeeBasisPoints(feeBps);
        }
      }
    };

    updateSwapAmounts();
  }, [
    isBuying,
    anchorOnSwapAmount,
    swapAmount,
    plpAmount,
    swapToken,
    swapTokenAddress,
    infoTokens,
    plpPrice,
    usdgSupply,
  ]);

  const switchSwapOption = (hash = "") => {
    history.push(`${history.location.pathname}#${hash}`);
    setIsBuying(hash === "redeem" ? false : true);
  };

  const fillMaxAmount = () => {
    if (isBuying) {
      setAnchorOnSwapAmount(true);
      setSwapValue(formatAmountFree(swapTokenBalance, swapToken.decimals, swapToken.decimals));
      return;
    }

    setAnchorOnSwapAmount(false);
    setPlpValue(formatAmountFree(maxSellAmount, GLP_DECIMALS, GLP_DECIMALS));
  };

  const getError = () => {
    if (IS_NETWORK_DISABLED[chainId]) {
      if (isBuying) return [t`GLP buy disabled, pending ${getChainName(chainId)} upgrade`];
      return [t`GLP sell disabled, pending ${getChainName(chainId)} upgrade`];
    }

    if (!isBuying && inCooldownWindow) {
      return [t`Redemption time not yet reached`];
    }

    if (!swapAmount || swapAmount.eq(0)) {
      return [t`Enter an amount`];
    }
    if (!plpAmount || plpAmount.eq(0)) {
      return [t`Enter an amount`];
    }

    if (isBuying) {
      const swapTokenInfo = getTokenInfo(infoTokens, swapTokenAddress);
      if (
        !savedShouldDisableValidationForTesting &&
        swapTokenInfo &&
        swapTokenInfo.balance &&
        swapAmount &&
        swapAmount.gt(swapTokenInfo.balance)
      ) {
        return [t`Insufficient ${swapTokenInfo.symbol} balance`];
      }

      if (swapTokenInfo.maxUsdgAmount && swapTokenInfo.usdgAmount && swapUsdMin) {
        const usdgFromAmount = adjustForDecimals(swapUsdMin, USD_DECIMALS, USDG_DECIMALS);
        const nextUsdgAmount = swapTokenInfo.usdgAmount.add(usdgFromAmount);
        if (swapTokenInfo.maxUsdgAmount.gt(0) && nextUsdgAmount.gt(swapTokenInfo.maxUsdgAmount)) {
          return [t`${swapTokenInfo.symbol} pool exceeded, try different token`, true];
        }
      }
    }

    if (!isBuying) {
      if (maxSellAmount && plpAmount && plpAmount.gt(maxSellAmount)) {
        return [t`Insufficient PLP balance`];
      }

      const swapTokenInfo = getTokenInfo(infoTokens, swapTokenAddress);
      if (
        swapTokenInfo &&
        swapTokenInfo.availableAmount &&
        swapAmount &&
        swapAmount.gt(swapTokenInfo.availableAmount)
      ) {
        return [t`Insufficient liquidity`];
      }
    }

    return [false];
  };

  const isPrimaryEnabled = () => {
    if (IS_NETWORK_DISABLED[chainId]) {
      return false;
    }
    if (!active) {
      return true;
    }
    const [error, modal] = getError();
    if (error && !modal) {
      return false;
    }
    if ((needApproval && isWaitingForApproval) || isApproving) {
      return false;
    }
    if (isApproving) {
      return false;
    }
    if (isSubmitting) {
      return false;
    }
    if (isBuying && isSwapTokenCapReached) {
      return false;
    }

    return true;
  };

  const getPrimaryText = () => {
    if (!active) {
      return t`Connect Wallet`;
    }
    const [error, modal] = getError();
    if (error && !modal) {
      return error;
    }
    if (isBuying && isSwapTokenCapReached) {
      return t`Max Capacity for ${swapToken.symbol} Reached`;
    }

    if (needApproval && isWaitingForApproval) {
      return t`Waiting for Approval`;
    }
    if (isApproving) {
      return t`Approving ${swapToken.symbol}...`;
    }
    if (needApproval) {
      return t`Approve ${swapToken.symbol}`;
    }

    if (isSubmitting) {
      return isBuying ? t`Buying...` : t`Selling...`;
    }

    return isBuying ? t`Buy PLP` : t`Sell PLP`;
  };

  const approveFromToken = () => {
    approveTokens({
      setIsApproving,
      library,
      tokenAddress: swapToken.address,
      spender: plpManagerAddress,
      chainId: chainId,
      onApproveSubmitted: () => {
        setIsWaitingForApproval(true);
      },
      infoTokens,
      getTokenInfo,
    });
  };

  const buyPlp = () => {
    setIsSubmitting(true);

    const minPlp = plpAmount.mul(BASIS_POINTS_DIVISOR - props.savedSlippageAmount).div(BASIS_POINTS_DIVISOR);

    const contract = new ethers.Contract(liquidityEventAddress, LiquidityEvent.abi, library.getSigner());
    const method = "mintAndStakePlp";
    const params = swapTokenAddress === AddressZero ? [0, minPlp] : [swapAmount, 0, minPlp];
    const value = swapTokenAddress === AddressZero ? swapAmount : 0;

    const setPendingTxns = props.setPendingTxns;
    callContract(chainId, contract, method, params, {
      value,
      sentMsg: t`Buy submitted.`,
      failMsg: t`Buy failed.`,
      successMsg: t`${formatAmount(plpAmount, 18, 4, true)} PLP bought with ${formatAmount(
        swapAmount,
        swapTokenInfo.decimals,
        4,
        true
      )} ${swapTokenInfo.symbol}!`,
      setPendingTxns,
      txnSuccessCallback: () => {
        setModalSuccessOpen(true);
        setIsSubmitting(false);
        setPlpValue("");
        setSwapValue("");
      },
    }).catch(() => {
      setIsSubmitting(false);
    });
  };

  const sellPlp = () => {
    setIsSubmitting(true);

    const minOut = swapAmount.mul(BASIS_POINTS_DIVISOR - props.savedSlippageAmount).div(BASIS_POINTS_DIVISOR);

    // const contract = new ethers.Contract(plpRewardRouterAddress, RewardRouter.abi, library.getSigner());
    const contract = new ethers.Contract(liquidityEventAddress, LiquidityEvent.abi, library.getSigner());
    const method = "unstakeAndRedeemPlp";
    const params = swapTokenAddress === AddressZero ? [plpAmount, minOut, account] : [plpAmount, minOut, account];

    const setPendingTxns = props.setPendingTxns;
    callContract(chainId, contract, method, params, {
      sentMsg: t`Sell submitted!`,
      failMsg: t`Sell failed.`,
      successMsg: t`${formatAmount(plpAmount, 18, 4, true)} PLP sold for ${formatAmount(
        swapAmount,
        swapTokenInfo.decimals,
        4,
        true
      )} ${swapTokenInfo.symbol}!`,
      setPendingTxns,
      txnSuccessCallback: () => {
        setModalSuccessOpen(true);
        setIsSubmitting(false);
        setPlpValue("");
        setSwapValue("");
      },
    }).catch(() => {
      setIsSubmitting(false);
    });
  };

  const onClickPrimary = () => {
    if (!active) {
      props.connectWallet();
      return;
    }

    if (needApproval) {
      approveFromToken();
      return;
    }

    const [, modal] = getError();

    if (modal) {
      setModalError(true);
      return;
    }

    if (isBuying) {
      buyPlp();
    } else {
      if (!isEventEnded && hasDestroyedRewardsOnSell(destroyAmounts)) {
        setModalWarningOpen(true);
      } else {
        sellPlp();
      }
    }
  };

  let payLabel = t`Pay`;
  let receiveLabel = t`Receive`;
  let payBalance = "$0.00";
  let receiveBalance = "$0.00";
  if (isBuying) {
    if (swapUsdMin) {
      payBalance = `$${formatAmount(swapUsdMin, USD_DECIMALS, 2, true)}`;
    }
    if (plpUsdMax) {
      receiveBalance = `$${formatAmount(plpUsdMax, USD_DECIMALS, 2, true)}`;
    }
  } else {
    if (plpUsdMax) {
      payBalance = `$${formatAmount(plpUsdMax, USD_DECIMALS, 2, true)}`;
    }
    if (swapUsdMin) {
      receiveBalance = `$${formatAmount(swapUsdMin, USD_DECIMALS, 2, true)}`;
    }
  }

  let feePercentageText = formatAmount(feeBasisPoints, 2, 2, true, "-");
  if (feeBasisPoints !== undefined && feeBasisPoints.toString().length > 0) {
    feePercentageText += "%";
  }

  const onSwapOptionChange = (opt) => {
    if (opt === t`sell`) {
      switchSwapOption("redeem");
    } else {
      switchSwapOption();
    }
    setActiveAction(opt);
  };


  const plpPriceHistory = useHourlyPlpStats(1)

  const lastSubgraphPrice = plpPriceHistory[0]?.price || bigNumberify(1)
  let currentPlpPrice = formatAmount(lastSubgraphPrice, USDG_DECIMALS, 3, true);
  if (priceFromChart) {
    currentPlpPrice = formatAmount(priceFromChart, USDG_DECIMALS, 3, true);
  }

  return (
    <SEO title={getPageTitle("Buy PALM or PLP")}>
      <div className="BuyGMXGLP page-layout">
        <BuyPlpModal open={modalSuccessOpen} action={isBuying ? "buy" : "sell"} setOpen={setModalSuccessOpen} />
        <SellPlpWarningModal
          open={modalWarningOpen}
          setOpen={setModalWarningOpen}
          sell={sellPlp}
          plpAmount={plpAmount}
        />

        <div className="BuyGMXGLP-container default-container">
          <div className="Tab-container">
            {tabsOptions.map((opt) => (
              <div className={cx("Tab-option", { active: isActive(opt) })} onClick={() => setActiveTab(opt)} key={opt}>
                Buy {opt}
              </div>
            ))}
          </div>
          {activeTab === tabsOptions[1] && (
            <>
              <div className="Page-title">
                <Trans>Buy {activeTab} on BNB Chain</Trans>
              </div>
              <div className="description">Currently available only on decentralized exchanges</div>
              <div className="Token-card">
                <div className="Text-image-container">
                  <img src={PalmToken} alt="token" className="Token-icon" />
                  <div className="Token-name">{activeTab}</div>
                </div>
                <div className="description">
                  PALM is the utility and governance token. Accrues 30% of the platform's generated fees.
                </div>
                <div className="Token-link-container">
                  <div className="description">Buy {activeTab} using Decentralized Exchange Aggregators:</div>
                  <a href={getLink()} className="Text-image-container" target="_blank" rel="noopener noreferrer">
                    <img src={Pancake} alt="PancakeSwap" className="Pancake-icon" />
                    <div className="Token-name">Buy {activeTab} on Pancakeswap</div>
                  </a>
                </div>
              </div>
            </>
          )}
          {activeTab === tabsOptions[0] && (
            <div className="w-full mt-[6.6rem] gap-3 flex tailwind h-full isolate">
              <div className="w-full flex flex-col gap-[2.5rem]">
                <div className="flex-col flex gap-[2.5rem] mb-[2rem]">
                  <div className="flex-col flex">
                    <div className="flex items-center gap-3">
                      <img className="w-[4.5rem] h-[4.5rem]" src={PlpToken} alt="plp" />
                      <p className="text-[2.0rem] font-semibold">
                        <Trans>PLP Price</Trans>
                      </p>
                    </div>
                    <p className="text-[3.6rem] font-semibold">${currentPlpPrice}</p>
                  </div>
                </div>

                <div
                  className="flex-col flex h-[28rem] border-b border-border pb-5"
                  onMouseLeave={() => setPriceFromChart(null)}
                >
                  <Chart interval={activeChartPeriod} setPriceFromChart={setPriceFromChart} />
                </div>
                <div className="flex justify-end">
                  {CHART_PERIODS_CONFIG.map((period) => (
                    <span
                      key={period.value}
                      onClick={() => setActiveChartPeriod(period.value)}
                      className={cx(
                        "w-[5rem] h-[3rem] text-inactive cursor-pointer leading-[3rem] align-middle text-center rounded-[1rem]",
                        {
                          "bg-background-3 text-white": isActiveChartPeriod(period.value),
                        }
                      )}
                    >
                      {period.label}
                    </span>
                  ))}
                </div>

                <div className="flex flex-col">
                  <div className="text-[2.4rem] font-semibold mb-[1.4rem]">Stats</div>
                  <div className="flex gap-[3.2rem] mb-[2.6rem]">
                    <div className="flex-col flex gap-2">
                      <p className="text-[1.4rem] text-inactive">
                        <Trans>Wallet</Trans>
                      </p>
                      <p className="text-[2.4rem]">{formatAmount(plpBalance, GLP_DECIMALS, 4, true)} PLP</p>
                    </div>
                    <div className="flex-col flex gap-2">
                      <p className="text-[1.4rem] text-inactive">
                        <Trans>Staked</Trans>
                      </p>
                      <p className="text-[2.4rem]">{formatAmount(plpBalance, GLP_DECIMALS, 4, true)} PLP</p>
                    </div>
                    <div className="flex-col flex gap-2">
                      <p className="text-[1.4rem] text-inactive">
                        <Trans>APR</Trans>
                      </p>
                      <p className="text-[2.4rem]">{formatAmount(totalApr, 2, 2, false)}%</p>
                    </div>
                    <div className="flex-col flex gap-2">
                      <p className="text-[1.4rem] text-inactive">
                        <Trans>Total Supply</Trans>
                      </p>
                      <p className="text-[2.4rem]">{formatAmount(plpSupply, GLP_DECIMALS, 4, true)} PLP</p>
                    </div>
                  </div>
                  <div className="flex gap-3 mb-[2.6rem]">
                    <a
                      className="bg-[rgba(255,255,255,0.05)] h-[3.5rem] rounded-full text-[1.4rem] px-[2.6rem] flex items-center"
                      href={`https://${chainId === TESTNET ? "testnet." : ""}bscscan.com/address/${plpAddress}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="flex items-center gap-1">
                        Bscscan
                        <FiArrowUpRight />
                      </div>
                    </a>
                    <a
                      className="bg-[rgba(255,255,255,0.05)] h-[3.5rem] rounded-full text-[1.4rem] px-[2.6rem] rounded-full flex items-center"
                      href="https://docs.palmswap.org/ecosystem/liquidity-providing-plp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="flex items-center gap-1">
                        Documentation
                        <FiArrowUpRight />
                      </div>
                    </a>
                  </div>
                  <div className="flex w-full h-px bg-border"></div>
                </div>
                <div className="flex flex-col">
                  <div className="text-[2.4rem] font-semibold mb-[1.4rem]">Liquidity</div>
                  <p className="text-[1.4rem] text-inactive mb-[2.4rem]">
                    <Trans>Fees are paid when PLP is bought or sold.</Trans>
                  </p>
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="h-[4rem] text-[1.2rem] text-inactive bg-background-3">
                        <th className="rounded-l-[1rem]">Token</th>
                        <th>Price</th>
                        <th>Available</th>
                        <th>Wallet</th>
                        <th>Fees</th>
                        <th className="rounded-r-[1rem] text-background-3">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visibleTokens.map((token) => {
                        let tokenFeeBps;
                        if (isBuying) {
                          const { feeBasisPoints: feeBps } = getBuyGlpFromAmount(
                            plpAmount,
                            token.address,
                            infoTokens,
                            plpPrice,
                            usdgSupply
                          );
                          tokenFeeBps = feeBps;
                        } else {
                          const { feeBasisPoints: feeBps } = getSellGlpToAmount(
                            plpAmount,
                            token.address,
                            infoTokens,
                            plpPrice,
                            usdgSupply
                          );
                          tokenFeeBps = feeBps;
                        }
                        const tokenInfo = getTokenInfo(infoTokens, token.address);
                        let managedUsd;
                        if (tokenInfo && tokenInfo.managedUsd) {
                          managedUsd = tokenInfo.managedUsd;
                        }

                        let balanceUsd;
                        if (tokenInfo && tokenInfo.minPrice && tokenInfo.balance) {
                          balanceUsd = tokenInfo.balance.mul(tokenInfo.minPrice).div(expandDecimals(1, token.decimals));
                        }
                        const tokenImage = importImage("ic_" + token.symbol.toLowerCase() + "_40.svg");
                        let isCapReached = tokenInfo.managedAmount?.gt(tokenInfo.maxUsdgAmount);

                        let amountLeftToDeposit = bigNumberify(0);
                        if (tokenInfo.maxUsdgAmount && tokenInfo.maxUsdgAmount.gt(0)) {
                          amountLeftToDeposit = tokenInfo.maxUsdgAmount
                            .sub(tokenInfo.usdgAmount)
                            .mul(expandDecimals(1, USD_DECIMALS))
                            .div(expandDecimals(1, USDG_DECIMALS));
                        }
                        if (amountLeftToDeposit.lt(0)) {
                          amountLeftToDeposit = bigNumberify(0);
                        }
                        function renderFees() {
                          const swapUrl = `https://app.1inch.io/#/${chainId}/swap/`;
                          switch (true) {
                            case (isBuying && isCapReached) || (!isBuying && managedUsd?.lt(1)):
                              return (
                                <Tooltip
                                  handle="NA"
                                  position="right-bottom"
                                  renderContent={() => (
                                    <div className="text-white">
                                      <Trans>
                                        Max pool capacity reached for {tokenInfo.symbol}
                                        <br />
                                        <br />
                                        Please mint PLP using another token
                                      </Trans>
                                      <br />
                                      <p>
                                        <ExternalLink href={swapUrl}>
                                          <Trans> Swap {tokenInfo.symbol} on 1inch</Trans>
                                        </ExternalLink>
                                      </p>
                                    </div>
                                  )}
                                />
                              );
                            case (isBuying && !isCapReached) || (!isBuying && managedUsd?.gt(0)):
                              return `${formatAmount(tokenFeeBps, 2, 2, true, "-")}${
                                tokenFeeBps !== undefined && tokenFeeBps.toString().length > 0 ? "%" : ""
                              }`;
                            default:
                              return "";
                          }
                        }

                        return (
                          <tr className="h-[6.5rem]" key={token.symbol}>
                            <td>
                              <div className="w-full h-full flex items-center justify-start ml-[1rem] gap-3">
                                <img className="w-[4rem] h-[3.5rem]" src={tokenImage} alt={token.symbol} />
                                <div className="flex-col text=[1.4rem] gap-1">
                                  <p>{token.name}</p>
                                  <p className="text-inactive">{token.symbol}</p>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-center">
                                ${formatKeyAmount(tokenInfo, "minPrice", USD_DECIMALS, 2, true)}
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-center">
                                {amountLeftToDeposit && amountLeftToDeposit.lt(0)
                                  ? "$0.00"
                                  : `$${formatAmount(amountLeftToDeposit, USD_DECIMALS, 2, true)}`}
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-center">
                                {formatKeyAmount(tokenInfo, "balance", tokenInfo.decimals, 2, true)} {tokenInfo.symbol}{" "}
                                ($
                                {formatAmount(balanceUsd, USD_DECIMALS, 2, true)})
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-center">{renderFees()}</div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="flex w-full h-px bg-border"></div>
                </div>
                <div className="flex flex-col">
                  <div className="text-[2.4rem] font-semibold mb-[1.4rem]">What is PLP?</div>
                  <p className="text-[1.4rem] text-inactive mb-3">
                    <Trans>
                      PLP is the liquidity provider token of the Palmswap Exchange platform, a decentralized exchange
                      built on the Binance Smart Chain. As a liquidity provider token, PLP represents a share of the
                      liquidity pool on the platform. Holders of PLP can earn a share of the trading fees generated on
                      the platform, in proportion to the amount of PLP they hold.
                      <br />
                      <br />
                      PLP is an index token that tracks the price of USDT, the stablecoin that is used as a base
                      currency on the Palmswap platform. This means that the price of PLP{showMoreText}
                    </Trans>
                  </p>
                  <div className="no-underline text-[1.4rem] text-main" onClick={handleShowMoreClick}>
                    {showMoreButtonText}
                  </div>
                </div>
              </div>
              <div
                className={cx([
                  "rounded-[2.5rem] w-[55rem] h-fit border bg-background-5-v2-only @container/card relative overflow-hidden rounded-[2.5rem] p-[2.5rem]",
                ])}
                key="card"
              >
                <div className="flex justify-between h-[3.5rem] bg-background-3 rounded-[1rem]">
                  {plpActions.map((action) => (
                    <div
                      key={action}
                      onClick={() => onSwapOptionChange(action)}
                      className={cx("flex w-full items-center justify-center rounded-[1rem]", {
                        "bg-[#2E3238]": isActiveAction(action),
                      })}
                    >
                      <p className="text-[1.4rem] capitalize">
                        <Trans>{action} PLP</Trans>
                      </p>
                    </div>
                  ))}
                </div>
                <div className="mt-4 flex flex-col items-stretch">
                  <form onSubmit={() => {}} noValidate>
                    <fieldset className="flex flex-col items-stretch Buy-fieldset">
                      {isBuying && (
                        <BuyInputSection
                          topLeftLabel={payLabel}
                          topRightLabel={t`Balance:`}
                          tokenBalance={`${formatAmount(swapTokenBalance, swapToken.decimals, 4, true)}`}
                          inputValue={swapValue}
                          onInputValueChange={onSwapValueChange}
                          showMaxButton={
                            swapValue !== formatAmountFree(swapTokenBalance, swapToken.decimals, swapToken.decimals)
                          }
                          onClickTopRightLabel={fillMaxAmount}
                          onClickMax={fillMaxAmount}
                          selectedToken={swapToken}
                          balance={payBalance}
                          ref={buyInputAmountRef}
                        >
                          <div className="selected-token">USDT</div>
                        </BuyInputSection>
                      )}
                      {!isBuying && (
                        <BuyInputSection
                          topLeftLabel={payLabel}
                          topRightLabel={t`Available:`}
                          tokenBalance={`${formatAmount(maxSellAmount, GLP_DECIMALS, 4, true)}`}
                          inputValue={plpValue}
                          onInputValueChange={onPlpValueChange}
                          showMaxButton={plpValue !== formatAmountFree(maxSellAmount, GLP_DECIMALS, GLP_DECIMALS)}
                          onClickTopRightLabel={fillMaxAmount}
                          onClickMax={fillMaxAmount}
                          balance={payBalance}
                          defaultTokenName={"GLP"}
                          ref={sellInputAmountRef}
                        >
                          <div className="selected-token">PLP</div>
                        </BuyInputSection>
                      )}

                      <div className="flex justify-center items-center -mt-[3rem] pointer-events-none">
                        <button
                          className="mt-[0em] w-[3rem] aspect-square rounded-full bg-main hover:bg-main-hover active:bg-main-active transition-colors flex items-center justify-center translate-y-[calc(50%-0.5rem)] pointer-events-auto"
                          onClick={() => {
                            setIsBuying(!isBuying);
                            switchSwapOption(isBuying ? "redeem" : "");
                          }}
                          type="button"
                        >
                          <div className="flex items-center">
                            <HiArrowNarrowUp className="-mr-1.5 mb-1" />
                            <HiArrowNarrowDown className="-ml-1.5 mt-1" />
                          </div>
                        </button>
                      </div>

                      {isBuying && (
                        <BuyInputSection
                          topLeftLabel={receiveLabel}
                          topRightLabel={t`Balance:`}
                          tokenBalance={`${formatAmount(plpBalance, GLP_DECIMALS, 4, true)}`}
                          inputValue={plpValue}
                          onInputValueChange={onPlpValueChange}
                          balance={receiveBalance}
                          defaultTokenName={"GLP"}
                        >
                          <div className="selected-token">PLP</div>
                        </BuyInputSection>
                      )}
                      {!isBuying && (
                        <BuyInputSection
                          topLeftLabel={receiveLabel}
                          topRightLabel={t`Balance:`}
                          tokenBalance={`${formatAmount(swapTokenBalance, swapToken.decimals, 4, true)}`}
                          inputValue={swapValue}
                          onInputValueChange={onSwapValueChange}
                          balance={receiveBalance}
                          selectedToken={swapToken}
                        >
                          <div className="selected-token">USDT</div>
                        </BuyInputSection>
                      )}
                      <div className="flex justify-between items-center text-[1.2rem] leading-[2.4rem] mb-[1rem]">
                        <div className="text-inactive">
                          <Trans>Fees</Trans>
                        </div>
                        <div>{isBuying && isSwapTokenCapReached ? "NA" : feePercentageText}</div>
                      </div>

                      <Button
                        variant="primary-action"
                        rounded
                        className="w-full capitalize"
                        onClick={onClickPrimary}
                        disabled={!isPrimaryEnabled()}
                      >
                        <Trans>{getPrimaryText()}</Trans>
                      </Button>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </SEO>
  );
}
